export default {
  title: 'Zahlung',
  description: 'Alle Transaktionen sind sicher und verschlüsselt.',
};
